import { OTA_STATE_TONE, type Tone } from '@constants/tones';
import { OTA_STATE_LABEL, versionText } from '@locales/id/updates';
import type { Gateway, OtaState } from '@lib/api';

export const isOnline = (g: Pick<Gateway, 'state'>) => g.state === 'online';
/** Display name: the label set at placement, else the device id. */
export const gatewayName = (g: Pick<Gateway, 'label' | 'gwId'>) => g.label || g.gwId;
/** Readers at a location: how many, how many connected. */
export const readerCounts = (gateways: Pick<Gateway, 'state'>[]) => ({ total: gateways.length, online: gateways.filter(isOnline).length });

/** States worth a badge next to a gateway's version: an update is under way, waiting, or went wrong. */
const QUIET: ReadonlySet<OtaState> = new Set(['none', 'installed']);

/**
 * A gateway's update state as the server computed it (`otaState`), with its target version, or null when there is
 * nothing to say (no update, or installed). The dashboard never derives the state itself.
 */
export function otaLabel(g: Pick<Gateway, 'otaState' | 'desiredVersion'>): { tone: Tone; text: string } | null {
  if (!g.otaState || QUIET.has(g.otaState)) return null;
  const text = OTA_STATE_LABEL[g.otaState];
  return { tone: OTA_STATE_TONE[g.otaState], text: g.desiredVersion ? `${text} · ${versionText(g.desiredVersion)}` : text };
}
